'use client';

import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { ArrowLeft, FileSearch } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        <div className="w-16 h-16 rounded-2xl bg-primary/8 border border-primary/20 flex items-center justify-center mx-auto mb-6">
          <FileSearch size={28} className="text-primary" />
        </div>
        <div className="flex items-center justify-center gap-2 mb-4">
          <AppLogo size={20} />
          <span className="font-bold text-sm text-foreground">LedgerPay</span>
        </div>
        <h1 className="text-4xl font-bold text-foreground mb-2">404</h1>
        <h2 className="text-lg font-semibold text-foreground mb-3">Page not found</h2>
        <p className="text-sm text-muted-foreground mb-8 leading-relaxed">
          The page you're looking for doesn't exist or has been moved. Check the URL or navigate back to your dashboard.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            href="/"
            className="inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground text-sm font-semibold px-6 py-2.5 rounded-lg hover:bg-primary/90 transition-colors"
          >
            <ArrowLeft size={15} />
            Back to Dashboard
          </Link>
          <Link
            href="/marketing"
            className="inline-flex items-center justify-center gap-2 border border-border text-foreground text-sm font-semibold px-6 py-2.5 rounded-lg hover:bg-muted transition-colors"
          >
            Visit Homepage
          </Link>
        </div>
      </div>
    </div>
  );
}